import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getGameById } from "../api/game";
import StartGameFlowLayout from "../components/StartGameFlowLayout";
import { ROUTES } from "../utils/constants";
import { updateStats } from "../utils/helpers";
import reglas1 from "../assets/avatares/reglas-1.mp4";

export default function GameIntroduction() {
	const navigate = useNavigate();
	const game = useSelector((state) => state.game);
	const group = useSelector((state) => state.group);
	const [loading, setLoading] = useState(false);

	const handleNext = () => {
		if (loading) return;
		setLoading(true);
		getGameById(game?._id).then((res) => {
			if (res.status === 200) {
				updateStats({
					...group,
					actualScenario: 1,
					time: 0,
					lastVisited: ROUTES.START_GAME,
				});
				navigate(ROUTES.START_GAME3, {
					state: { activeScenario: 1 },
				});
			} else {
				setLoading(false);
			}
		});
	};

	return (
		<StartGameFlowLayout
			brandTheme
			sidebarTitle="Reglas Dinámica I"
			loading={loading}
			onContinue={handleNext}
			video={reglas1}
		>
			<div className="start-game-rule-block">
				<h3>Trabajo en equipo</h3>
				<p>
					En esta dinámica, formaréis parte de un comité de transformación, que debe decidir cómo integrar la inteligencia artificial dentro de una empresa.
				</p>
			</div>
			<div className="start-game-rule-block">
				<h3>Toma de decisiones</h3>
				<p>
					Trabajaréis en equipo con una tablet, analizaréis la información que aparezca en cada fase y tendréis que consensuar vuestras decisiones.
				</p>
				<p>
					A lo largo del recorrido resolveréis retos sobre diagnóstico, selección de casos de uso, implantación, gestión del cambio y gobierno responsable de la IA.
				</p>
			</div>
			<div className="start-game-rule-block">
				<h3>Puntuación del equipo</h3>
				<p>
					Cada decisión tendrá una puntuación distinta. Al final, vuestro resultado reflejará cómo habéis equilibrado innovación, riesgo, datos, adopción interna y criterio profesional.
				</p>
			</div>
		</StartGameFlowLayout>
	);
}
